/* global $, Modernizr, _ */

;$(function () {
  'use strict'

  var headroomClasses = {
    initial: 'header__headroom',
    pinned: 'header__headroom_pinned',
    unpinned: 'header__headroom_unpinned',
    top: 'header__headroom_top',
    notTop: 'header__headroom_not-top'
  }

  var isMobilised = $('.layout_mobilised').length > 0
  var $root = $('.header__desktop .header')

  if ($root.length > 0) {
    var $dropdowns = $root.find('.header__tags__tag__dropdown')
    var $links = $root.find('.header__tags__tag__link')
    var $items = $root.find('.header__menu__item__link')
    var $bottomLine = $root.find('.header__bottom-line')
    var cachedWindowHeight
    var cachedDropHeightResult

    $bottomLine.headroom({
      tolerance: {
        down: 4,
        up: 2
      },
      classes: headroomClasses,
      onPin: function () {
        $root.addClass('header_top-line-wo-shadow')
      },
      onUnpin: function () {
        $root.removeClass('header_top-line-wo-shadow')
      }
    })

    $items.on('mouseenter', function () {
      if ($bottomLine.is('.header__headroom_unpinned.header__headroom_not-top')) {
        $bottomLine
          .removeClass('header__headroom_unpinned')
          .addClass('header__headroom_pinned')

        $root.addClass('header_top-line-wo-shadow')
      }
    })

    // SCROLL UP

    var descrollAfterAnchor = function () {
      $(window).scrollTop(
          $(window).scrollTop() - $root.outerHeight(true)
      )
    }

    $(window).on('load', function () {
      // scroll up if user came on page with digit hash (like a forum topic page),
      // otherwise menu hides top of post
      if (document.location.hash.search(/^#\d+$/) !== -1 || document.location.hash.search(/^#.*_sh$/) !== -1) {
        descrollAfterAnchor()
      }
    })

    $(document).on('click', 'a[href*="#"]', function () {
      // scroll up if user clicks a link with digit hash (like a forum topic page),
      // otherwise menu hides top of post

      if ($(this).attr('href').search(/\/#\d+$/) !== -1) {
        var linkPage = $(this).attr('href').match(/\/forum\d+?\/.+\#/).toString().replace(/\/#/, '').replace(/\/page\d+/, '')

        if (Boolean(document.location.pathname.match(linkPage))) {
          setTimeout(function () {
            descrollAfterAnchor()
          }, 1)
        }
      }
    })

    // DROPDOWNS

    var calucalateMaxDropHeight = function () {
      var windowHeight = $(window).height()
      var result

      var headerHeight = (function () {
        var result = 0
        $root.children().each(function () {
          result += $(this).outerHeight(true)
        })
        return result
      }())

      if (windowHeight !== cachedWindowHeight) {
        var dropElmHeight = $links.outerHeight(true)
        var maxCount = Math.floor((windowHeight - headerHeight) / dropElmHeight)

        result = (maxCount * dropElmHeight) - Math.round(0.5 * dropElmHeight)
        cachedDropHeightResult = result
      }
      else {
        result = cachedDropHeightResult
      }

      return result
    }

    $(window).on('scroll.header debouncedresize.header', function () {
      if (Modernizr.touch) {
        return
      }

      if ($(window).width() <= 1280 && !isMobilised) {
        $dropdowns.css('max-height', calucalateMaxDropHeight())
        return false
      }

      $dropdowns.css('max-height', calucalateMaxDropHeight())
      cachedWindowHeight = $(window).height()
    })

    if (Modernizr.touch) {
      $(document).on('click', '.header__desktop .header__tags > .header__tags__tag > .header__tags__tag__link', function (event) {
        if ($(this).parents('.header__tags__tag').find('.header__tags__tag__dropdown').length < 1) {
          $(this).parents('.header__tags__tag').addClass('header__tags__tag_shown')
          return
        }

        if (!$(this).parents('.header__tags__tag').hasClass('header__tags__tag_shown')) {
          event.preventDefault()
          $('.header__tags__tag_shown').removeClass('header__tags__tag_shown')
          $(this).parents('.header__tags__tag').addClass('header__tags__tag_shown')
        }
      })

      $(document).on('click', function () {
        $('.header__desktop .header__tags__tag_shown').removeClass('header__tags__tag_shown')
      })

      $(document).on('click', '.header__desktop .header__tags > .header__tags__tag', function (event) {
        event.stopPropagation()
      })
    }
  }

  var $mobile = $('.layout_mobilised .header__mobile .header')

  if ($mobile.length > 0) {
    var $modalBackdropds = $('.header__mobile.modall .modall__backdrop')
    var $burger = $('.header__hamburger')

    $modalBackdropds.each(function () {
      $(this).width($burger.outerWidth())
    })

    var $headroom = $mobile.find('.header__headroom')

    $headroom.headroom({
      offset: $mobile.height(),
      tolerance: {
        up: ($(window).height() / 24),
        down: 2
      },
      classes: headroomClasses
    })
  }

  _([$root, $mobile]).each(function ($elm) {
    var heightination = function () {
      var height = 0

      $elm.children().each(function () {
        height += $(this).outerHeight(true)
      })

      $elm.parent().css('height', height)
    }

    heightination()
    $(window).on('debouncedresize.header', heightination)
  })

  // Search desktop
  var $searchPanel = $('[data-search-panel]')
  var $searchPanelHandle = $('[data-search-panel-handle]')
  var $searchPanelClose = $('[data-search-panel-close]')
  var $searchBackLayer = $('<div></div>').addClass('userbar__search-back-layer')
  var $searchPanelInput = $('[data-search-panel-input]')

  var createSearchBackLayer = function () {
    $searchPanel.addClass('userbar__search-panel_active')
    $('body').append($searchBackLayer)
  }

  var onPanelClose = function () {
    $searchPanel.removeClass('userbar__search-panel_active')
    $('.userbar__search-back-layer').remove()
    $searchPanelInput.focusout()
    closeHashtagDropdown()
  }

  $searchPanelHandle.on('click', function () {
    createSearchBackLayer()
    $searchBackLayer.on('click', onPanelClose)
    $searchPanelInput.focus()
  })

  $searchPanelClose.on('click', onPanelClose)

  // Search mobile
  var $searchMobileHandle = $('[data-search-mobile-handle]')
  var $searchMobileClose = $('[data-search-mobile-close]')
  var $searchMobileOverlay = $('[data-search-mobile-overlay]')
  var $searchMobileInput = $('[data-search-mobile-input]')

  $searchMobileHandle.on('click', function () {
    $searchMobileOverlay.addClass('header__search-overlay_active')
    $searchMobileInput.focus()
  })

  $searchMobileClose.on('click', function () {
    $searchMobileOverlay.removeClass('header__search-overlay_active')
    $searchMobileInput.focusout()
  })

  // Hashtags
  var ENTER_KEY_CODE = 13
  var HASHTAGS_SEARCH_QUERY_URL = '/hashtags/'

  var $searchSelect = $('[data-search-select]')
  var $searchSubmit = $('[data-search-submit]')
  var $searchHashtag = $('[data-search-hashtag]')
  var $searchHashtagBox = $('[data-search-hashtag-box]')
  var $searchHashtagSubmit = $('[data-search-hashtag-submit]')

  function changeSearchElementsVisibility (element) {
    if (element.val() === 'hashtag') {
      $searchPanelInput.hide()
      $searchMobileInput.hide()
      $searchSubmit.hide()
      $searchHashtagBox.show()
      $searchHashtagSubmit.show()
    }
    else {
      $searchPanelInput.show()
      $searchMobileInput.show()
      $searchSubmit.show()
      $searchHashtagBox.hide()
      $searchHashtagSubmit.hide()
    }
  }

  function closeHashtagDropdown () {
    if ($searchHashtagDropdown.css('display') === 'block') {
      $searchHashtagDropdown.select2('close')
    }
  }

  function getNoun (number, one, two, five) {
    var n = Math.abs(number)
    n %= 100
    if (n >= 5 && n <= 20) {
      return five
    }
    n %= 10
    if (n === 1) {
      return one
    }
    if (n >= 2 && n <= 4) {
      return two
    }
    return five
  }

  $searchHashtag.select2({
    placeholder: 'Поиск',
    dropdownCssClass: 'userbar__search-dropdown',
    minimumInputLength: 1,
    query: function (query) {
      $.getJSON(HASHTAGS_SEARCH_QUERY_URL + '?q=' + query.term)
        .success(function (response) {
          var data = { results: [] }
          $.each(response, function (index, value) {
            data.results.push({
              id: value.id,
              text: value.title,
              posts: value.blog_posts_qty,
              blogs: value.blogs_qty,
              objects: value.objects_qty
            })
          })
          query.callback(data)
        })
    },
    formatInputTooShort: function () {
      return 'Начните печатать'
    },
    formatResult: function (item) {
      var result = item.objects + getNoun(item.objects, ' результат', ' результата', ' результатов')
      return '#' + item.text + '<span class="userbar__search-type">' + result + '</span>'
    }
  })

  var $searchHashtagDropdown = $('.userbar__search-dropdown')
  var $searchHashtagInput = $('.userbar__search-dropdown .select2-input')

  $searchHashtag.on('change', function (event) {
    var hashtag = event.added.text
    var blogsAmount = event.added.blogs
    var postsAmount = event.added.posts
    var type = (blogsAmount > postsAmount) ? '/blogs/' : '/posts/'
    var url = HASHTAGS_SEARCH_QUERY_URL + hashtag + type
    $(location).attr('href', url)
  })

  $searchHashtag.on('select2-open', function () {
    $searchSelect.css('pointer-events', 'none')
    $searchPanel.on('click', function () {
      closeHashtagDropdown()
    })
  })

  $searchHashtag.on('select2-close', function () {
    $searchSelect.css('pointer-events', 'all')
  })

  $searchSelect.on('change', function () {
    changeSearchElementsVisibility($(this))
  })

  $searchMobileOverlay.on('click', function () {
    closeHashtagDropdown()
  })

  $searchHashtagInput.on('input', function () {
    var value = $(this).val()
    $searchHashtagSubmit.val(value)
  })

  $searchHashtagInput.on('keydown', function (event) {
    if (event.which === ENTER_KEY_CODE) {
      $searchHashtagSubmit.trigger('click')
    }
  })

  $searchHashtagSubmit.on('click', function () {
    var hashtag = $(this).val()
    var url = HASHTAGS_SEARCH_QUERY_URL + '?q=' + hashtag
    $(location).attr('href', url)
  })

  changeSearchElementsVisibility($searchSelect)
})
